<template lang="pug">
  e-chart(
    :header="`${documentTitle}`"
    :options="chartMSNContainerOptions"
    :series="chartMSNContainerSeries"
    chartId="msnContainer"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
  )

</template>
<script>
  import chartsMixin from '../mixins/charts-mixin.js'

  export default {
    mixins: [chartsMixin],
    created () {
      this.fetchData()
    },
    watch: {
      'fields.msnContainer.viewMode': {
        handler: function(v) {
          this.viewMode = v
          this.fetchData()
        }
      }
    },
    computed: {
      viewMode: {
        get: function () {
          return this.$store.getters.charts.msnContainer.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {msnContainer: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('msnContainer')
      }
    },
    methods: {
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            type: 'container',
            viewMode: this.viewMode
          }
        })
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartMSNContainerSeries = this.transform(r)
        })
      }
    }
  }
</script>

<style>
  .pie-donut-caption {
    path: 'src/app/analytic/components/chart-msn-container.vue';
    font-size: 38px;
  }
</style>
